<script setup>
import moment from 'moment'
import { Link } from '@inertiajs/vue3'
import Base from '@/Components/Cards/Base.vue'
import UserAvatar from '@/Components/Users/UserAvatar.vue'

defineProps({
  user: Object,
})
</script>

<template>
  <Base>
    <Link :href="route('members.show', user.id)" class="flex" rel="nofollow">
      <UserAvatar :user="user" />
      <div class="mx-4 my-auto w-full overflow-hidden">
        <p class="mb-2 truncate font-serif text-xl">{{ user.name }}</p>
        <p class="text-sm text-gray-500">
          {{ parseInt(user.reputation).toLocaleString() }} Reputation
        </p>
        <p class="text-sm text-gray-500">Joined {{ moment(user.created_at).format('MMM Y') }}</p>
      </div>
    </Link>
  </Base>
</template>
